@if (!!item) {
<svg height="100%" width="100%" viewBox="-24.7 8 249.4 304"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <clipPath [attr.id]="'cb-clip-' + item.id">
      <path d="M94 72 C78 78 70 92 70 110 L70 246 C70 258 80 264 100 264 C120 264 130 258 130 246 L130 110 C130 92 122 78 106 72 Z"/>
    </clipPath>
  </defs>

  <!-- Liquid fill (clipped to the jug body) -->
  <rect [attr.clip-path]="'url(#cb-clip-' + item.id + ')'" x="70" [attr.y]="y" [attr.height]="height" width="60" [attr.fill]="item.color || item.beverage?.color || '#d99a2b'"/>

  <!-- Glass body (translucent) -->
  <path d="M94 72 C78 78 70 92 70 110 L70 246 C70 258 80 264 100 264 C120 264 130 258 130 246 L130 110 C130 92 122 78 106 72 Z" fill="#d6ece6" fill-opacity="0.30" stroke="#232323" stroke-width="1.5"/>
  <!-- Glass highlight -->
  <path d="M80 108 C78 150 78 210 82 244" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" opacity="0.5"/>

  <!-- Neck -->
  <rect x="93" y="46" width="14" height="28" fill="#d6ece6" fill-opacity="0.5" stroke="#8fb6ac" stroke-width="1.5"/>

  <!-- Rubber bung -->
  <path d="M88 46 L112 46 L109 40 L91 40 Z" fill="#c98f5a" stroke="#9c6b3f"/>

  <!-- 3-piece airlock -->
  <rect x="97" y="26" width="6" height="14" fill="#cfe0ea" stroke="#8fb6cc"/>
  <ellipse cx="100" cy="22" rx="6" ry="7" fill="#cfe0ea" stroke="#8fb6cc"/>
  <rect x="97" y="16" width="6" height="4" fill="#8fb6cc"/>
</svg>
}
